import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ExcelFile from './excel-file';
import ExcelFileDetail from './excel-file-detail';
import ExcelFileUpdate from './excel-file-update';
import ExcelFileDeleteDialog from './excel-file-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ExcelFileUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ExcelFileUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ExcelFileDetail} />
      <ErrorBoundaryRoute path={match.url} component={ExcelFile} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ExcelFileDeleteDialog} />
  </>
);

export default Routes;
